import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useLang } from '../i18n/context';
import useUserStore from '../store/userStore';
import BrandMark from './BrandMark';
import './GlobalNav.css';

function GlobalNav() {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useLang();
  const { isLoggedIn, userInfo, logout } = useUserStore();
  const [menuOpen, setMenuOpen] = useState(false);
  const [csOpen, setCsOpen] = useState(false);

  const isHome = location.pathname === '/';
  const subnavPaths = ['/tools', '/pattern-match', '/dump-detective', '/support-resistance', '/gold-calculator', '/airdrop', '/market-heatmap', '/market', '/jin10-news', '/social', '/crypto', '/stock', '/institution', '/institutions', '/fundamentals'];
  const isProPage = subnavPaths.some(p => location.pathname.startsWith(p));
  const urlMode = new URLSearchParams(location.search).get('mode');
  const currentMode = urlMode || (isProPage ? 'pro' : 'growth');
  const showSubnav = currentMode === 'pro' || isProPage;

  const switchMode = (mode) => {
    if (isHome) {
      navigate(mode === 'pro' ? '/?mode=pro' : '/', { replace: true });
    } else {
      navigate(mode === 'pro' ? '/?mode=pro' : '/');
    }
  };

  const isActive = (path) => {
    if (path === '/') return isHome ? 'gn-link active' : 'gn-link';
    return location.pathname.startsWith(path) ? 'gn-link active' : 'gn-link';
  };
  const isDrawerActive = (path) => path === '/'
    ? isHome
    : location.pathname.startsWith(path);
  const drawerItemClass = (path) => `gn-drawer-item${isDrawerActive(path) ? ' active' : ''}`;

  const goHome = () => {
    if (isHome) {
      document.getElementById('hero')?.scrollIntoView({ behavior: 'smooth' });
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      navigate('/');
    }
  };

  const handleLogout = () => {
    logout();
    setMenuOpen(false);
    navigate('/');
  };

  const displayUsername = userInfo.username && userInfo.username.length > 12
    ? userInfo.username.substring(0, 10) + '...'
    : userInfo.username;

  const [mobileOpen, setMobileOpen] = useState(false);

  const mobileNav = (path) => {
    navigate(path);
    setMobileOpen(false);
  };

  return (
    <nav className="gn">
      <div className="gn-inner">
        <button className="gn-logo" onClick={goHome}>
          GHOST
          <BrandMark className="gn-logo-mark" />
        </button>
        <div className="gn-links">
          <div className="gn-mode-toggle">
            <button
              className={`gn-mode-btn${currentMode === 'growth' ? ' active' : ''}`}
              onClick={() => switchMode('growth')}
            >{t('home.modeGrowth')}</button>
            <button
              className={`gn-mode-btn${currentMode === 'pro' ? ' active' : ''}`}
              onClick={() => switchMode('pro')}
            >{t('home.modePro')}</button>
          </div>
          <button className={isActive('/docs')} onClick={() => navigate('/docs')}>{t('home.navDocs')}</button>
          <button className={isActive('/books')} onClick={() => navigate('/books')}>书籍</button>
          <button className={isActive('/social')} onClick={() => navigate('/social')}>{t('social.navLabel')}</button>
          <button className={isActive('/rebate')} onClick={() => navigate('/rebate')}>{t('home.navRebate')}</button>
        </div>
        <div className="gn-actions">
          {/* 客服入口 */}
          <div className="gn-cs-wrap">
            <button
              className="gn-cs-btn"
              onClick={() => setCsOpen(!csOpen)}
              onBlur={() => setTimeout(() => setCsOpen(false), 150)}
              aria-label={t('cs.label')}
            >
              <svg width="18" height="18" fill="none" viewBox="0 0 24 24">
                <path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </button>
            {csOpen && (
              <div className="gn-cs-panel">
                <div className="gn-cs-panel-title">{t('cs.title')}</div>
                <div className="gn-cs-panel-item gn-cs-wechat" onClick={() => {
                  navigator.clipboard.writeText('admiraltyz');
                  const tip = document.getElementById('cs-copy-tip');
                  if (tip) { tip.textContent = t('cs.copied'); setTimeout(() => { tip.textContent = t('cs.copyTip'); }, 1500); }
                }}>
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M8.691 2.188C3.891 2.188 0 5.476 0 9.53c0 2.212 1.17 4.203 3.002 5.55a.59.59 0 01.213.665l-.39 1.48c-.019.07-.048.141-.048.213 0 .163.13.295.29.295a.326.326 0 00.167-.054l1.903-1.114a.864.864 0 01.717-.098 10.16 10.16 0 002.837.403c.276 0 .543-.027.811-.05a6.42 6.42 0 01-.246-1.79c0-3.558 3.39-6.451 7.585-6.451.258 0 .509.025.764.042C16.672 4.627 13.034 2.188 8.691 2.188zm-2.35 4.477a.97.97 0 110 1.94.97.97 0 010-1.94zm5.321 0a.97.97 0 110 1.94.97.97 0 010-1.94zM23.997 15.39c0-3.248-3.236-5.882-7.229-5.882-3.992 0-7.228 2.634-7.228 5.882 0 3.248 3.236 5.882 7.228 5.882.79 0 1.55-.103 2.275-.289a.69.69 0 01.574.078l1.525.89a.26.26 0 00.133.044c.13 0 .232-.105.232-.236 0-.058-.023-.114-.039-.17l-.312-1.186a.472.472 0 01.171-.532c1.462-1.075 2.39-2.648 2.39-4.39zm-9.725-1.357a.78.78 0 110 1.56.78.78 0 010-1.56zm4.993 0a.78.78 0 110 1.56.78.78 0 010-1.56z"/></svg>
                  <span className="gn-cs-wechat-info">
                    <strong>WeChat</strong>
                    <em id="cs-copy-tip">{t('cs.copyTip')}</em>
                  </span>
                  <span className="gn-cs-wechat-id">admiraltyz</span>
                </div>
                <div className="gn-cs-panel-divider" />
                <div className="gn-cs-panel-item gn-cs-feedback" onClick={() => { setCsOpen(false); }}>
                  <svg width="18" height="18" fill="none" viewBox="0 0 24 24">
                    <path d="M9 11l3 3L22 4M21 12v7a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h11" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  <span>{t('cs.feedback')}</span>
                  <span className="gn-cs-soon">{t('cs.comingSoon')}</span>
                </div>
              </div>
            )}
          </div>
          {isLoggedIn ? (
            <div className="gn-user-wrap">
              <button
                className="gn-user-btn"
                onClick={() => setMenuOpen(!menuOpen)}
                onBlur={() => setTimeout(() => setMenuOpen(false), 150)}
              >
                <svg width="18" height="18" fill="none" viewBox="0 0 24 24">
                  <circle cx="12" cy="8" r="4" fill="var(--accent-secondary)" opacity="0.6"/>
                  <path d="M4 20c0-4 4-6 8-6s8 2 8 6" stroke="var(--accent-secondary)" strokeWidth="2" strokeLinecap="round"/>
                </svg>
                <span>{displayUsername}</span>
                <svg width="10" height="10" fill="none" viewBox="0 0 12 12">
                  <path d={menuOpen ? "M3 8L6 5L9 8" : "M3 5L6 8L9 5"} stroke="var(--accent-secondary)" strokeWidth="1.5" strokeLinecap="round"/>
                </svg>
              </button>
              {menuOpen && (
                <div className="gn-user-menu">
                  <div className="gn-user-menu-item" onClick={() => { navigate('/profile'); setMenuOpen(false); }}>
                    {t('nav.profile')}
                  </div>
                  <div className="gn-user-menu-item gn-user-menu-logout" onClick={handleLogout}>
                    {t('nav.logout')}
                  </div>
                </div>
              )}
            </div>
          ) : (
            <>
              <button className="gn-btn-outline" onClick={() => navigate('/login')}>{t('home.login')}</button>
              <button className="gn-btn-primary" onClick={() => navigate('/register')}>{t('home.register')}</button>
            </>
          )}
          {/* 汉堡按钮 */}
          <button
            className="gn-hamburger"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label={mobileOpen ? '关闭菜单' : '打开菜单'}
            aria-expanded={mobileOpen}
            aria-controls="gn-mobile-drawer"
          >
            <svg width="22" height="22" fill="none" viewBox="0 0 24 24">
              {mobileOpen ? (
                <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
              ) : (
                <path d="M4 7h16M4 12h16M4 17h16" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
              )}
            </svg>
          </button>
        </div>
      </div>

      {/* 专业版子导航 */}
      {showSubnav && (
        <div className="gn-pro-subnav">
          <div className="gn-pro-subnav-inner">
            <button
              className={`gn-pro-subnav-btn${isHome && currentMode === 'pro' ? ' active' : ''}`}
              onClick={() => navigate('/?mode=pro')}
            >{t('home.proNavOverview')}</button>
            <button
              className={`gn-pro-subnav-btn${location.pathname === '/market' ? ' active' : ''}`}
              onClick={() => navigate('/market')}
            >市场雷达</button>
            <button
              className={`gn-pro-subnav-btn${location.pathname.startsWith('/tools') ? ' active' : ''}`}
              onClick={() => navigate('/tools')}
            >{t('home.proNavTools')}</button>
            <button
              className={`gn-pro-subnav-btn${location.pathname === '/market-heatmap' ? ' active' : ''}`}
              onClick={() => navigate('/market-heatmap')}
            >{t('home.proNavHeatmap')}</button>
            <button
              className={`gn-pro-subnav-btn${location.pathname === '/jin10-news' ? ' active' : ''}`}
              onClick={() => navigate('/jin10-news')}
            >资讯</button>
            <button
              className={`gn-pro-subnav-btn${location.pathname === '/gold-calculator' ? ' active' : ''}`}
              onClick={() => navigate('/gold-calculator')}
            >黄金</button>
            <button
              className={`gn-pro-subnav-btn${location.pathname.startsWith('/institution') ? ' active' : ''}`}
              onClick={() => navigate('/institutions')}
            >{t('home.proNavHoldings')}</button>
            <button
              className={`gn-pro-subnav-btn${location.pathname === '/fundamentals' ? ' active' : ''}`}
              onClick={() => navigate('/fundamentals')}
            >{t('home.proNavFundamentals')}</button>
            <button
              className={`gn-pro-subnav-btn${location.pathname === '/airdrop' ? ' active' : ''}`}
              onClick={() => navigate('/airdrop')}
            >{t('home.proNavAirdrop')}</button>
            <button
              className={`gn-pro-subnav-btn${location.pathname.startsWith('/social') ? ' active' : ''}`}
              onClick={() => navigate('/social')}
            >{t('home.proNavCommunity')}</button>
          </div>
        </div>
      )}

      {/* 移动端顶部下拉菜单 */}
      <div className={`gn-drawer-backdrop${mobileOpen ? ' open' : ''}`} onClick={() => setMobileOpen(false)} />
      <div
        id="gn-mobile-drawer"
        className={`gn-drawer${mobileOpen ? ' open' : ''}`}
        role="dialog"
        aria-modal="true"
        aria-hidden={!mobileOpen}
        aria-label="移动端导航菜单"
      >
        <div className="gn-drawer-header">
          <div className="gn-drawer-brand-wrap">
            <span className="gn-drawer-brand">GHOST</span>
            <span className="gn-drawer-subtitle">Web3 Community</span>
          </div>
          <button className="gn-drawer-close" onClick={() => setMobileOpen(false)} aria-label="关闭菜单">
            <svg width="20" height="20" fill="none" viewBox="0 0 24 24">
              <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
            </svg>
          </button>
        </div>
        <div className="gn-drawer-body">
          <div className="gn-drawer-section-label">模式切换</div>
          <div className="gn-drawer-mode-toggle">
            <button
              className={`gn-mode-btn${currentMode === 'growth' ? ' active' : ''}`}
              onClick={() => { switchMode('growth'); setMobileOpen(false); }}
            >{t('home.modeGrowth')}</button>
            <button
              className={`gn-mode-btn${currentMode === 'pro' ? ' active' : ''}`}
              onClick={() => { switchMode('pro'); setMobileOpen(false); }}
            >{t('home.modePro')}</button>
          </div>
          <div className="gn-drawer-divider" />
          <div className="gn-drawer-section-label">快速导航</div>
          <button className={drawerItemClass('/docs')} onClick={() => mobileNav('/docs')}>
            <svg width="18" height="18" fill="none" viewBox="0 0 24 24"><path d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
            {t('home.navDocs')}
          </button>
          <button className={drawerItemClass('/social')} onClick={() => mobileNav('/social')}>
            <svg width="18" height="18" fill="none" viewBox="0 0 24 24"><path d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
            {t('social.navLabel')}
          </button>
          <button className={drawerItemClass('/rebate')} onClick={() => mobileNav('/rebate')}>
            <svg width="18" height="18" fill="none" viewBox="0 0 24 24"><path d="M12 8v13m0-13V6a2 2 0 112 2h-2zm0 0V5.5A2.5 2.5 0 109.5 8H12zm-7 4h14M5 12a2 2 0 110-4h14a2 2 0 110 4M5 12v7a2 2 0 002 2h10a2 2 0 002-2v-7" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
            {t('home.navRebate')}
          </button>
          <div className="gn-drawer-divider" />
          {isLoggedIn ? (
            <>
              <button className="gn-drawer-item" onClick={() => mobileNav('/profile')}>
                <svg width="18" height="18" fill="none" viewBox="0 0 24 24"><path d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
                {t('nav.profile')}
              </button>
              <button className="gn-drawer-item gn-drawer-logout" onClick={() => { handleLogout(); setMobileOpen(false); }}>
                <svg width="18" height="18" fill="none" viewBox="0 0 24 24"><path d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
                {t('nav.logout')}
              </button>
            </>
          ) : (
            <div className="gn-drawer-auth">
              <button className="gn-drawer-auth-login" onClick={() => mobileNav('/login')}>{t('home.login')}</button>
              <button className="gn-drawer-auth-register" onClick={() => mobileNav('/register')}>{t('home.register')}</button>
            </div>
          )}
        </div>
      </div>
    </nav>
  );
}

export default GlobalNav;
